// https://codeburst.io/create-a-search-pipe-to-dynamically-filter-results-with-angular-4-21fd3a5bec5c

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterTabBy'
})
export class FilterTabByPipe implements PipeTransform {

    transform(items: any[], searchText: string): any[] {

        if (!items)
            return [];

        if (!searchText)
            return items;

        return items.filter(items => items.tabname === searchText);
    }
}
